import {
  GA_CONSENT_STORAGE_KEY,
  GA_REQUIRE_CONSENT,
} from './constants';
import type { Ga4ConsentStatus } from './types';

export function readStoredAnalyticsConsent(): Ga4ConsentStatus {
  if (typeof window === 'undefined') return 'pending';
  if (!GA_REQUIRE_CONSENT) return 'granted';

  try {
    const raw = localStorage.getItem(GA_CONSENT_STORAGE_KEY);
    if (raw === 'granted') return 'granted';
    if (raw === 'denied') return 'denied';
    return 'pending';
  } catch {
    return 'pending';
  }
}

export function writeStoredAnalyticsConsent(status: 'granted' | 'denied'): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(GA_CONSENT_STORAGE_KEY, status);
  } catch {
    // ignore quota / private mode
  }
}

export function isAnalyticsConsentGranted(): boolean {
  return readStoredAnalyticsConsent() === 'granted';
}
